export default "__VITE_ASSET__CDeNgRqI__"